const en = {

    campus : "ชื่อสถาบันอุดมศึกษา",
    faculty: "สำนักวิชา",
    department: "สาขาวิชา",
    academicYear:"ปีการศึกษา",
    semester:"ภาคการศึกษา",
    course:"เลือกรายวิชา",

    header: {
        home: "หน้าหลัก",
        artworks: "ผลงานศิลปะ",
        news: "ข่าวสาร",
        about: "เกี่ยวกับเรา",
        login: "เข้าสู่ระบบ",
        profile: "โปรไฟล์",
        history: "ประวัติการสั่งซื้อ",
        submissions: "ผลงานที่ส่ง",
        dashboard: "แดชบอร์ด",
        logout: "ออกจากระบบ",
        cart: "ตะกร้าสินค้า",
        contact: "ติดต่อเรา"
    },

    button: {
        setting:"ตั้งค่า",
        create :"สร้าง",
    },

    description : "รายละเอียด",

    sidebar: {
        main: "หน้าหลัก",
        overview: "ภาพรวม",
        analytics: "วิเคราะห์ข้อมูล",
        operations: "การดำเนินการ",
        orders: "คำสั่งซื้อ",
        artworks: "ผลงานศิลปะ",
        news: "ข่าวสาร",
        submissions: "ผลงานที่ส่ง",
        dataCenter: "ศูนย์ข้อมูล",
        users: "จัดการผู้ใช้งาน",
        settings: "ตั้งค่าระบบ",
        returnToWebsite: "กลับไปหน้าหลัก",
        signOut: "ออกจากระบบ"
    }
}
export default en

